const urlVal = new URL(window.location.href);

export const getParam = (param: string) => urlVal.searchParams.get(param);

export const saveParam = (param: string, param1?: string) => {
  const paramValue = getParam(param);
  paramValue && localStorage.setItem(param1 || param, paramValue);
};

saveParam('channel');

saveParam('code', 'inviteCode');
